import { WithNAFallback } from '@design';
import { getPriceStatus } from '@helpers';
import { priceChangeColors } from '@terminal/utils/common/utils';
import React from 'react';

import {
  formatNumberWithUnit,
  formatPercentageNumber,
} from '../../utils/utils';
import styles from './NumberCell.module.scss';

interface NumberCellProps {
  value: number | undefined;
  percentage?: boolean;
  useFallbackDash?: boolean;
  fallbackTooltip?: string;
  includePercentSign?: boolean;
}

export const NumberCell = ({
  value,
  percentage,
  useFallbackDash,
  fallbackTooltip,
  includePercentSign = true,
}: NumberCellProps) => {
  const formattedValue = percentage
    ? formatPercentageNumber({ value, includePercentSign, addPlus: percentage })
    : formatNumberWithUnit(value);

  return (
    <span
      className={styles.numberTableValue}
      style={{ color: priceChangeColors[getPriceStatus(value)] }}
    >
      <WithNAFallback
        containerPadding="0 0 0 8px"
        check={formattedValue !== '-'}
        value={formattedValue}
        useFallbackDash={useFallbackDash}
        tooltip={fallbackTooltip}
      />
    </span>
  );
};
